import { ArrowDropDown } from "@mui/icons-material"
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Step, StepButton, Stepper, TextField, Autocomplete, Tooltip, FormControlLabel, Switch } from "@mui/material"
import { ClearIcon } from "@mui/x-date-pickers"
import colors from "assets/theme/base/colors"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDEditor from "components/MDEditor"
import MDTypography from "components/MDTypography"
import React, { useState } from "react"
import moment from "moment";
import { useMaterialUIController } from "context";

export const CreateOpeningDialog = ({ openDialog, closeDialog, isSmallScreen, selectedHiringFlow, handleOpenHiringFlow, permissions, modulePermissions, jobAdvertisementPayload, setJobAdvertisementPayload, handleAddRecord, handleSaveClick, formError }) => {

	const [hoverText, setHoverText] = useState("");
	const [activeStep, setActiveStep] = React.useState(0);
	const [completed, setCompleted] = React.useState({});

	const steps = ['JOB DESCRIPTION', 'JOB DETAILS', 'PUBLISH OPTIONS'];
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

	const totalSteps = () => {
		return steps.length;
	};

	const completedSteps = () => {
		return Object.keys(completed).length;
	};

	const isLastStep = () => {
		return activeStep === totalSteps() - 1;
	};

	const allStepsCompleted = () => {
		return completedSteps() === totalSteps();
	};

	const handleNext = () => {
		const newActiveStep =
			isLastStep() && !allStepsCompleted()
				? // It's the last step, but not all steps have been completed, find the first step that has been completed
				steps.findIndex((step, i) => !(i in completed))
				: activeStep + 1;
		setActiveStep(newActiveStep);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleStep = (step) => () => {
		setActiveStep(step);
	};

	const handleReset = () => {
		setActiveStep(0);
		setCompleted({});
	};

	const handleMouseEnter = (step) => {
		if (step.flow_stages?.length) {
			setHoverText(
				step.flow_stages.map((stage, index) => (
					<MDTypography key={index} variant="body2" sx={{ display: "block", fontSize: "12px" }}>
						{stage.name}
					</MDTypography>
				))
			);
		} else {
			setHoverText(
				<MDTypography variant="body2">No stages available</MDTypography>
			);
		}
	};

	return (
		<>
			<Dialog
				PaperProps={{
					style: {
						backgroundColor: "white",
						boxShadow: "none",
						width: "100%",
						maxWidth: "none",
						padding: "0px !important",
						borderRadius: "10px",
						height: "100%",
					},
				}}
				open={openDialog}
				onClose={() => closeDialog()}
			>
				<DialogTitle display='flex' alignItems='center' m={3}>
					<MDTypography variant='h4'>
						{jobAdvertisementPayload?.type === "update" ? "Update Opening" : "Create New Opening"}
					</MDTypography>
				</DialogTitle>
				<DialogContent sx={{ height: '100%' }}>
					<Stepper
						nonLinear
						activeStep={activeStep}
						orientation='horizontal'
						sx={{
							padding: 2,
						}}
					>
						{steps?.map((label, index) => (
							<Step key={label} completed={completed[index]} sx={{ display: "flex", alignItems: 'center' }}>
								<StepButton onClick={handleStep(index)}>
									<span style={{ marginTop: '0px !important' }}>{label}</span>
								</StepButton>
							</Step>
						))}
						<IconButton sx={{ position: 'absolute', right: 15, top: 18 }}
							onClick={() => closeDialog()}
						>
							<ClearIcon />
						</IconButton>
					</Stepper>
					<MDBox sx={{ height: "80%" }}>
						{
							allStepsCompleted() ?
								<MDBox sx={{ borderRadius: "14px", display: "flex", justifyContent: 'center', alignItems: "center", backgroundColor: !darkMode && colors.background.accent, marginTop: 2, height: '100%', flexDirection: "column" }}>
									<MDTypography variant='h4' sx={{ mt: 2, mb: 1 }}>
										Congratulations !!!!
									</MDTypography>
									<MDTypography variant='body1' sx={{ mt: 2, mb: 1 }}>
										All the steps are completed, you can now proceed with the creation of new job profile.
									</MDTypography>
									<MDBox sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
										<MDBox sx={{ flex: '1 1 auto' }} />
										<MDButton onClick={handleReset}>Reset</MDButton>
									</MDBox>
								</MDBox>
								:
								<MDBox sx={{ borderRadius: "14px", display: "flex", backgroundColor: !darkMode && colors.background.accent, marginTop: 2, height: '100%', flexDirection: "column" }}>
									{activeStep === 0 && (
										<MDBox >
											<Grid container spacing={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: "center", padding: 3 }}>
												<Grid item xs={12} sm={4}>
													<TextField
														type="text"
														variant='outlined'
														name="Position"
														value={jobAdvertisementPayload?.position}
														onChange={(event) => {
															setJobAdvertisementPayload((state) => ({
																...state,
																position: event.target.value,
															}));
															//setPositionError("");
														}}
														required
														label='Position'
													/>
												</Grid>
												<Grid item xs={12} sm={4}>
													<TextField
														type="text"
														variant='outlined'
														name="Education"
														required
														label='Education'
														value={jobAdvertisementPayload.education}
														onChange={(event) => {
															setJobAdvertisementPayload((state) => ({
																...state,
																education: event.target.value,
															}));
															//setEducationError("");
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={4}>
													<TextField
														type="text"
														variant='outlined'
														name="Experience"
														required
														label='Experience'
														value={jobAdvertisementPayload.experience}
														onChange={(event) => {
															setJobAdvertisementPayload((state) => ({
																...state,
																experience: event.target.value,
															}));
															//setExperienceError("");
														}}
													/>
												</Grid>
											</Grid>
											<Grid item xs={12} sx={{ mt: 2 }}>
												<MDEditor
													value={jobAdvertisementPayload.description || ""}
													onChange={(val) => {
														const inputValue = val;
														setJobAdvertisementPayload((state) => ({
															...state,
															description: val,
														}));
														//setDescriptionError("");
													}}
													style={{ margin: '30px', backgroundColor: "White" }}
												/>
												<p
													style={{
														color: "red",
														fontSize: 13,
														fontWeight: "lighter",
													}}
												>
													{" "}
													{/*{descriptionError ? "This field may not be blank*" : ""}*/}
												</p>
											</Grid>
										</MDBox>
									)}

									{activeStep === 1 && (
										<MDBox sx={{ padding: "40px" }}>
											<Grid container spacing={3}>
												<Grid item xs={12} sm={4}>
													<TextField
														variant="outlined"
														name="vacancy"
														value={jobAdvertisementPayload.vacancy}
														onChange={(event) => {
															setJobAdvertisementPayload((prevState) => ({
																...prevState,
																vacancy: event.target.value,
															}));
															//setVacancyError("");
														}}
														type="number"
														required
														fullWidth
														label="Vacancy"
													//error={!!vacancyError}
													//helperText={vacancyError}
													/>
												</Grid>
												<Grid item xs={12} sm={4}>
													<TextField
														variant="outlined"
														id="deadline"
														type="date"
														label="Deadline"
														name="deadline"
														fullWidth
														required
														value={moment(jobAdvertisementPayload.deadline).format(
															"YYYY-MM-DD"
														)}
														onChange={(event) => {
															setJobAdvertisementPayload((prevState) => ({
																...prevState,
																deadline: event.target.value,
															}));
															//setDescriptionError("");
														}}
													// error={!!deadlineError}
													// helperText={deadlineError}
													/>
												</Grid>
												<Grid item xs={12} sm={4}>
													<TextField
														variant="outlined"
														id="post_date"
														type="date"
														label="Post Date"
														fullWidth
														value={moment(jobAdvertisementPayload.post_date).format(
															"YYYY-MM-DD"
														)}
														name="post_date"
														onChange={(event) => {
															setJobAdvertisementPayload((prevState) => ({
																...prevState,
																post_date: event.target.value,
															}));
														}}
														InputProps={{}}
													/>
												</Grid>
												<Grid item xs={12} sm={4}>
													<FormControlLabel
														control={(
															<Switch
																checked={Boolean(jobAdvertisementPayload.show_salary)}
																onChange={(event) => {
																	setJobAdvertisementPayload((prevState) => ({
																		...prevState,
																		show_salary: event.target.checked,
																	}));
																}}
															/>
														)}
														label="Show Salary"
													/>
												</Grid>
												{jobAdvertisementPayload.show_salary && (
													<>
														<Grid item xs={12} sm={4}>
															<TextField
																variant="outlined"
																name="min_ctc"
																value={jobAdvertisementPayload.min_ctc}
																onChange={(event) => {
																	setJobAdvertisementPayload((prevState) => ({
																		...prevState,
																		min_ctc: event.target.value,
																	}));
																}}
																type="number"
																fullWidth
																label="Minimum CTC"
															/>
														</Grid>
														<Grid item xs={12} sm={4}>
															<TextField
																variant="outlined"
																name="max_ctc"
																value={jobAdvertisementPayload.max_ctc}
																onChange={(event) => {
																	setJobAdvertisementPayload((prevState) => ({
																		...prevState,
																		max_ctc: event.target.value,
																	}));
																}}
																type="number"
																fullWidth
																label="Maximum CTC"
															/>
														</Grid>
													</>
												)}
												<Grid item xs={12} sx={{ mt: 2 }}>
													<Autocomplete
														multiple
														id="tags-filled"
														value={jobAdvertisementPayload.skills || []}
														options={[]}
														sx={{
															"&.MuiAutocomplete-noOptions": {
																display: "none",
															},
														}}
														onChange={(event, values) => {
															setJobAdvertisementPayload((prevState) => ({
																...prevState,
																skills: values,
															}));
														}}
														freeSolo={true}
														renderInput={(params) => (
															<TextField {...params} variant="outlined" placeholder="Skills" />
														)}
													/>
												</Grid>
												<Grid item xs={12} sx={{ mt: 2 }}>
													<MDBox sx={{ display: "flex", gap: "10px" }}>
														<MDTypography sx={{ fontSize: "16px", mb: 2 }}>Hiring Flow</MDTypography>
														<MDTypography sx={{ fontSize: "14px", mb: 2, mt: 0.2, color: "blue", cursor: "pointer" }} onClick={handleOpenHiringFlow}>Change</MDTypography>
													</MDBox>
													<MDBox
														sx={{
															width: "100%",
															display: "flex",
															flexWrap: "wrap",
															alignItems: "center",
															border: "1px solid",
															borderColor: "divider",
															borderRadius: 1,
															bgcolor: "background.paper",
															color: "text.secondary",
															height: { xs: "auto", md: "50px" }, // Dynamic height for small screens
														}}
													>
														{selectedHiringFlow
															? selectedHiringFlow?.map((step, index, array) => (
																<React.Fragment key={step}>
																	<MDTypography
																		sx={{
																			fontSize: "14px",
																			textAlign: "center",
																			flex: { xs: "1 1 100%", md: 1 }, // Full width on small screens
																			padding: { xs: "10px 0", md: 0 },
																		}}
																	>
																		{step.name}
																		<Tooltip
																			arrow
																			title={<>{hoverText}</>}
																			componentsProps={{
																				tooltip: {
																					sx: {
																						backgroundColor: "#fff",
																						color: "#000000",
																						boxShadow: 1,
																						border: "1px solid #ccc",
																					},
																				},
																				arrow: {
																					sx: {
																						color: "black",
																					},
																				},
																			}}
																		>
																			<MDTypography
																				component="span"
																				sx={{
																					fontSize: "12px",
																					display: "block",
																					color: "#2B2B2B",
																					cursor: "pointer"
																				}}
																				onMouseEnter={() => handleMouseEnter(step)}
																				onMouseLeave={() => setHoverText("")}
																			>
																				{step.flow_stages?.length || 0} stages
																				<ArrowDropDown />
																			</MDTypography>
																		</Tooltip>
																	</MDTypography>
																	{index < array.length - 1 && (

																		<MDBox
																			sx={{
																				width: "20px",
																				height: "40px",
																				display: { xs: "none", md: "block" },
																				position: "relative",
																			}}
																		>
																			<svg width="20" height="40" viewBox="0 0 20 60">
																				<line x1="10" y1="0" x2="10" y2="15" stroke="#666666" strokeWidth="1" />
																				<path
																					d="M10 15 C 20 25, 20 35, 10 45"
																					stroke="#666666"
																					strokeWidth="1"
																					fill="none"
																				/>
																				<line x1="10" y1="45" x2="10" y2="60" stroke="#666666" strokeWidth="1" />
																			</svg>
																		</MDBox>
																	)}
																</React.Fragment>
															))
															: (
																<>
																	{[
																		"Source",
																		"Screening",
																		"Interview",
																		"Preboarding",
																		"Hired",
																		"Archived",
																	].map((step, index, array) => (
																		<React.Fragment key={step}>
																			<MDTypography
																				sx={{
																					fontSize: "14px",
																					textAlign: "center",
																					flex: { xs: "1 1 100%", md: 1 }, // Full width on small screens
																					padding: { xs: "10px 0", md: 0 },
																				}}
																			>
																				{step}
																			</MDTypography>
																			{index < array.length - 1 && (

																				<MDBox
																					sx={{
																						width: "20px",
																						height: "40px",
																						display: { xs: "none", md: "block" },
																						position: "relative",
																					}}
																				>
																					<svg width="20" height="40" viewBox="0 0 20 60">
																						<line x1="10" y1="0" x2="10" y2="15" stroke="#666666" strokeWidth="1" />
																						<path
																							d="M10 15 C 20 25, 20 35, 10 45"
																							stroke="#666666"
																							strokeWidth="1"
																							fill="none"
																						/>
																						<line x1="10" y1="45" x2="10" y2="60" stroke="#666666" strokeWidth="1" />
																					</svg>
																				</MDBox>
																			)}
																		</React.Fragment>
																	))}
																</>
															)}
													</MDBox>
												</Grid>
											</Grid>
											{formError ? (
												<MDTypography sx={{ color: colors.error.main, mt: 2, fontSize: "0.875rem" }}>
													{formError}
												</MDTypography>
											) : null}
										</MDBox>
									)}

									{activeStep === 2 && (
										<MDBox display='flex' justifyContent='center' flexDirection='column' alignItems='center' margin='70px'>
											<MDTypography variant="h6" color='black' mt={3} mb={3}>You’re about to publish a new job advertisement.</MDTypography>
											<MDTypography variant="h4" color='black' mb={3}>Once created, this position will be visible for recruitment and candidate tracking.</MDTypography>
											<MDTypography variant="body2" color='black' mb={3}>Please confirm to continue.</MDTypography>
											<MDBox display='flex' marginTop='24px' gap='8px'>
												<MDButton
													variant="gradient"
													color="dark"
													onClick={() => closeDialog()}
												>
													Cancel
												</MDButton>
												{(permissions.includes(
													modulePermissions?.jobAdvertisement?.update_permission
												) ||
													permissions?.includes(
														modulePermissions?.jobAdvertisement?.create_permission
													)) && (
														<MDButton
															variant="gradient"
															color="dark"
														onClick={() => {
															if (jobAdvertisementPayload.type === "update") {
																handleSaveClick();
															} else {
																handleAddRecord();
															}
														}}
														>
															{jobAdvertisementPayload.type === "update" ? "Update" : "Create"}
														</MDButton>
													)}
											</MDBox>
										</MDBox>
									)}
								</MDBox>
						}
					</MDBox>
				</DialogContent>
				<DialogActions
					sx={{
						display: "flex",
						flexDirection: isSmallScreen ? "column" : "row",
						alignItems: isSmallScreen ? "center" : "flex-start",
						justifyContent: "space-between",
						padding: isSmallScreen ? "0px 20px" : "0px 60px",
						gap: isSmallScreen ? 2 : 0,
					}}
				>
					<MDBox>
						{activeStep !== totalSteps() - 1 && (
							<MDBox sx={{
								display: "flex",
								// justifyContent: "space-between",
								justifyContent: isSmallScreen ? "center" : "space-between",
								width: "100%",
								padding: "0px 15px",
								marginTop: isSmallScreen ? "90px" : "15px",
							}}>
								<MDButton
									variant="gradient"
									color="dark"
									onClick={() => closeDialog()}
								>
									Cancel
								</MDButton>
							</MDBox>
						)}
					</MDBox>
					<MDBox sx={{
						display: 'flex',
						flexDirection: isSmallScreen ? "column" : "row",
						pt: 2,
					}}>
						<MDButton
							variant="gradient"
							color="dark"
							disabled={activeStep === 0}
							onClick={handleBack}
							sx={{ mr: 1 }}
						>
							Back
						</MDButton>
						<MDBox sx={{ flex: '1 1 auto' }} />
						<MDButton
							variant="gradient"
							color="dark"
							disabled={activeStep === totalSteps() - 1}
							onClick={handleNext}
							sx={{
								mr: 1, marginTop: isSmallScreen ? "20px" : "0px",
							}}
						>
							Continue
						</MDButton>
						{/* {activeStep !== steps.length &&
                    (completed[activeStep] ? (
                      <Typography variant="caption" sx={{ display: 'inline-block' }}>
                        Step {activeStep + 1} already completed
                      </Typography>
                    ) : (
                      <Button onClick={handleComplete}>
                        {completedSteps() === totalSteps() - 1
                          ? 'Finish'
                          : 'Complete Step'}
                      </Button>
                    ))} */}
					</MDBox>
				</DialogActions>
			</Dialog>
		</>
	)

}
